const tooltipPalette = (tokens) => {
    return {
        padding: tokens.tooltipPadding,
        font: {
            family: tokens.tooltipFontFamily,
            size: tokens.tooltipFontSize,
            lineHeight: tokens.tooltipLineHeight,
            weight: tokens.tooltipFontWeight,
            letterSpacing: tokens.tooltipLetterSpacing
        },
        border: {
            width: tokens.tooltipBorderWidth,
            radius: tokens.tooltipRadius,
            default: tokens.tooltipColorBorder
        },
        background: {
            default: tokens.tooltipColorBg
        },
        text: tokens.tooltipColorText
    };
};
export default tooltipPalette;
//# sourceMappingURL=tooltip.js.map